import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import './index.css';
import AgentWrapper from './agent/AgentWrapper';

posthog.init(
  process.env.REACT_APP_PUBLIC_POSTHOG_KEY || '',
  {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    person_profiles: 'identified_only',
  }
);

function App() {
  const path = window.location.pathname;
  let match = path.match(/^\/agent-embed(-product)?(-draft)?\/([^\/]+)$/);
  
  if (!match) {
    return <div>Page not found</div>;
  }

  const isDraft = !!match[2];
  const agentId = match[3];

  return (
    <PostHogProvider client={posthog}>
      <AgentWrapper 
        agentId={agentId}
        isDraft={isDraft}
      />
    </PostHogProvider>
  );
}

export default App;